import FairDashBoardPage from './FairDashBoardPage.jsx';

export {
  FairDashBoardPage
}


// WEBPACK FOOTER //
// ./pages/fair/index.js